import { useCallback, useMemo, useSyncExternalStore } from "react";
import { useMutation } from "@tanstack/react-query";
import { useTRPC } from "../trpc.js";
import { getChatSubscriptionStore } from "../stores/chatSubscriptionStore.js";
const emptyMessages = [];
export function useChatStore(styleId, chatId) {
    const trpc = useTRPC();
    const store = getChatSubscriptionStore(styleId);
    const subscribe = useCallback((listener) => store.subscribeChat(chatId, listener), [store, chatId]);
    const getSnapshot = useCallback(() => store.getChatSnapshot(chatId), [store, chatId]);
    const chat = useSyncExternalStore(subscribe, getSnapshot);
    const { mutate: sendMessageMutation } = useMutation(trpc.sendStyleEditorMessage.mutationOptions());
    const sendMessage = useCallback((chatIdToSend, message) => {
        store.addOptimisticMessage(chatIdToSend, message);
        sendMessageMutation({
            message,
            editor: "style",
        });
    }, [store, sendMessageMutation]);
    return useMemo(() => ({
        messages: chat?.messages ?? emptyMessages,
        summary: chat?.summary ?? "",
        status: chat?.status ?? "done",
        sendMessage,
    }), [chat?.messages, chat?.summary, chat?.status, sendMessage]);
}
